module.exports = __webpack_public_path__ + "img/depoimento-7.ff844aff.png";